export default __webpack_public_path__ + "resources/icons/n420-ad71.webp";